module.exports = __webpack_public_path__ + "img/close.0651a874.svg";